import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.invitedentity', []);
})();
